// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, setPersistence, browserLocalPersistence } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
// Removed getFunctions - using Node.js backend instead of Cloud Functions
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBDxGeqSk1xheSRAtk6HTZNcKqC_LNankE",
  authDomain: "to-do-app-dcdb3.firebaseapp.com",
  projectId: "to-do-app-dcdb3",
  storageBucket: "to-do-app-dcdb3.firebasestorage.app",
  messagingSenderId: "190624201750",
  appId: "1:190624201750:web:2c2d842af364481bdcc937",
  measurementId: "G-259PEFN7CL"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth();

// Set auth persistence to LOCAL (survives page refresh, browser close, navigation)
// This ensures users stay logged in across sessions
// Credentials are stored securely in browser's key store (IndexedDB/localStorage)
// User will remain logged in until they manually logout
setPersistence(auth, browserLocalPersistence)
  .then(() => {
    console.log("✅ Auth persistence set to LOCAL - credentials saved securely");
    console.log("✅ User will stay logged in until manual logout");
  })
  .catch((error) => {
    console.error("❌ Error setting auth persistence:", error);
  });

export const db = getFirestore(app);
// ⭐ Secondary app for admin-created users (prevents logout)
export const secondaryApp = initializeApp(firebaseConfig, "Secondary");
export const secondaryAuth = getAuth(secondaryApp);

// Initialize Firebase Cloud Messaging
// Note: getMessaging() can only be called in browser environment
let messaging = null;
if (typeof window !== "undefined" && "serviceWorker" in navigator) {
  try {
    messaging = getMessaging(app);
  } catch (error) {
    console.warn("Firebase Messaging initialization failed:", error);
  }
}

export { messaging, getToken, onMessage };

// Removed functions export - using Node.js backend instead
export default app;
